import { mapGetters } from "vuex";

/**
 * content filters, as editing text
 */
export const dataFilters = {
  filters: {
    ripCode: function (str) {
      if (str) {
        return str.split(":").pop();
      } else {
        return;
      }
    },
  },
};

/**
 * Control accordions in navigation
 */
export const accordionControl = {
  data() {
    return {
      activeBtn: null,
    };
  },
  methods: {
    // toggle accordion, if there's other accordion open in same list of accordions, close those.
    toggleAccordion: (event, activeDataType = null, target = null, forceClose = false) => {
      let eventTarget = null;

      if (activeDataType && target) {
        // Special case for initial load: open accordion of activeDataType element
        if (activeDataType === target) {
          eventTarget = document.getElementById(activeDataType);
        } else {
          return;
        }
      } else {
        // Normal operation, use clicked target element
        eventTarget = event.target;
      }

      for (const element of eventTarget.parentElement.parentElement.querySelectorAll(".accordion-parent")) {
        if (element.querySelector("BUTTON") != eventTarget || forceClose) {
          element.querySelector("BUTTON").nextElementSibling.style.maxHeight = null;
          for (
            let i = 0;
            i < element.querySelector("BUTTON").nextElementSibling.getElementsByTagName("BUTTON").length;
            i++
          ) {
            element
              .querySelector("BUTTON")
              .nextElementSibling.getElementsByTagName("BUTTON")
              [i].setAttribute("tabindex", "-1");
          }
        }
      }

      if (eventTarget.nextElementSibling.style.maxHeight || forceClose) {
        // Button and its child elements are open --> close accordion

        for (let i = 0; i < eventTarget.nextElementSibling.getElementsByTagName("BUTTON").length; i++) {
          eventTarget.nextElementSibling.getElementsByTagName("BUTTON")[i].setAttribute("tabindex", "-1");
          eventTarget.setAttribute("aria-expanded", "false");
          eventTarget.nextElementSibling.setAttribute("aria-hidden", "true");
        }
        eventTarget.nextElementSibling.style.maxHeight = null;

        // Remove focus from button
        // eventTarget.blur();
      } else {
        // Button and its child elements are closed --> open accordion

        for (let i = 0; i < eventTarget.nextElementSibling.getElementsByTagName("BUTTON").length; i++) {
          eventTarget.nextElementSibling.getElementsByTagName("BUTTON")[i].setAttribute("tabindex", "0");
          eventTarget.setAttribute("aria-expanded", "true");
          eventTarget.nextElementSibling.setAttribute("aria-hidden", "false");
        }
        eventTarget.nextElementSibling.style.maxHeight = `${eventTarget.nextElementSibling.scrollHeight}px`;
      }
    },
  },
};

/**
 * Control general accessibility in templates with common functionality
 * (accordion accessibility in toggleAccordion method)
 */
export const accessibilityControls = {
  computed: {
    ...mapGetters(["activeMapButton"]),
  },
  methods: {
    changeFocus: function () {
      document.querySelector(`#${CSS.escape(this.activeMapButton)}`).focus();
    },
  },
};
